import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SeasonTipsComponent } from '../season-tips/season-tips.component';
import { popupDirective } from '@shared/directives/popup.directive';

@Component({
  selector: 'iho-hotel-rules-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, SeasonTipsComponent, popupDirective],
  templateUrl: './hotel-rules-modal.component.html',
  styleUrls: ['./hotel-rules-modal.component.scss'],
})
export class HotelRulesModalComponent implements OnInit {

  modalData: any;

  constructor(@Inject(MAT_DIALOG_DATA) data: { data: any },
    public dialogRef: MatDialogRef<HotelRulesModalComponent>) {
    this.modalData = data;
  }

  ngOnInit(): void {

  }

  closeModal() {
    this.dialogRef.close();

  }
}
